<section class="ui-stat-card">
  <p class="ui-stat-card__label">{{ label() | uiLabelTranslate }}</p>
  <p class="ui-stat-card__value">{{ value() }}</p>
  @if (delta()) {
    <p class="ui-stat-card__delta">{{ delta() }}</p>
  }
</section>
